module.exports = __webpack_public_path__ + "static/img/logo-vrs.9831d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-vrs.png
// module id = JVuK
// module chunks = 1